import React, { useState } from 'react';
import { Button, Card, CardTitle, CardBody, CardFooter, CardImg, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, CardText, Badge } from 'reactstrap';
import CardSender from './CardSender';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Carddass(props) {
    const {card, count, selected, setSelected, showImage} = props;
    const [modal, setModal] = useState(false);

    const toggle = () => {
        if(count !== 0) {
            if(typeof(selected) != "undefined") {
                if(setSelected) {
                    setSelected(card.id);
                }
            } else {
                setModal(!modal);
            }
        }
    }

    return (
        <Card className="carddass" onClick={toggle}>
            {selected &&
            <Badge pill color="success"><FontAwesomeIcon icon="check" /></Badge>
            } 
            {(count !== 0 || showImage)
            ? <CardImg src={props.card.frontThumbnailImageURL}></CardImg>
            : <CardImg src="https://placehold.jp/240/d1d1d1/ffffff/300x436.png?text=%3F"></CardImg>
            }
            <CardBody>
                <CardTitle>{card.title}</CardTitle>
            </CardBody>
            <Modal isOpen={modal} toggle={toggle} className="carddass-modal">
                <ModalHeader toggle={toggle}>{card.title}</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xs="12" sm="6">
                            <img src={card.frontImageURL} width="100%" alt="" />
                        </Col>
                        <Col xs="12" sm="6">
                            <img src={card.backImageURL} width="100%" alt="" />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {0 < count && <p>{count}枚持っています</p>}
                    <div className="ml-auto nowrap text-right">
                        {0 < count && <CardSender card={card} />}
                        {' '}
                        <Button color="secondary" onClick={toggle}>閉じる</Button>
                    </div>
                </ModalFooter>
            </Modal>
        </Card>
    );
}